module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('canvas', {
    directives: [{
      name: "celebration",
      rawName: "v-celebration",
      value: ({
        type: _vm.type,
        color: _vm.color,
        delay: _vm.delay
      }),
      expression: "{ type, color, delay }"
    }],
    staticClass: "celebration"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51f568c3","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/elements/Celebration.vue
// module id = mYC5
// module chunks = 1